export const CARD_BREAKPOINTS = {
  mobile: 520,
  tablet: 900,
  desktop: 1200,
  large: 1201,
} as const;

export const CARD_MIN_WIDTHS = {
  mobile: CARD_BREAKPOINTS.mobile + 1,
  tablet: CARD_BREAKPOINTS.tablet + 1,
} as const;

export const MINI_CARD_BREAKPOINTS = {
  mobile: 894,
  tablet: 1100,
  desktop: 1352,
  large: 1353,
} as const;

export const MINI_CARD_MIN_WIDTHS = {
  mobile: MINI_CARD_BREAKPOINTS.mobile + 1,
  tablet: MINI_CARD_BREAKPOINTS.tablet + 1,
} as const;
